<script setup lang="ts">
  import { useDashboard } from '@/models/dashboard.ts'
  import ChartOrders from './chart-orders.vue'
  import ChartRevenue from './chart-revenue.vue'

  const { loading, data, chartPeriod, getData } = useDashboard()

  getData()
</script>

<template>
  <div>
    <div class="mb-4 ml-auto w-48 bg-white">
      <app-select v-model="chartPeriod">
        <option value="7_days">
          7 Hari Terakhir
        </option>
        <option value="12_months">
          12 Bulan Terakhir
        </option>
        <option value="5_years">
          5 Tahun Terakhir
        </option>
      </app-select>
    </div>
    <div
      v-if="loading"
      class="flex h-64 items-center justify-center text-gray-400">
      Memuat Data...
    </div>
    <div
      v-else-if="data"
      class="grid grid-cols-1 gap-x-8 gap-y-4 xl:grid-cols-2">
      <app-card>
        <chart-orders
          title="Pesanan"
          :data="data.order_stats" />
      </app-card>
      <app-card>
        <chart-revenue
          title="Omset"
          :data="data.revenue_stats" />
      </app-card>
    </div>
    <app-empty
      v-else-if="data == undefined"
      icon="i-far-chart-line"
      title="Data tidak ditemukan" />
  </div>
</template>
